import { StoredWorkSessionsState, WorkSession, WorkSessionsState } from 'src/models/workSessions';

const SESSION: WorkSession = {
  workDurationSeconds: 45 * 60,
  breakDurationSeconds: 15 * 60,
  durationSeconds: 60 * 60,
};

const SESSIONS_COUNT = 8;

export const getNowTimestamp = (): number => new Date().valueOf();

const defaultStoredState: StoredWorkSessionsState = {
  currentSession: 1,
  sessionTimePassedSeconds: 0,
  playTimestamp: null,
};

export const getWorkoutSessionsState = (
  initialState: StoredWorkSessionsState = defaultStoredState
): WorkSessionsState => {
  const nowTimestamp = getNowTimestamp();
  let { currentSession, playTimestamp, sessionTimePassedSeconds } = initialState;
  let actualSessionTimePassed = sessionTimePassedSeconds;

  if (playTimestamp) {
    const diff = (nowTimestamp - playTimestamp) / 1000;

    actualSessionTimePassed += diff;

    if (actualSessionTimePassed >= SESSION.durationSeconds) {
      playTimestamp = null;
      sessionTimePassedSeconds = 0;
      actualSessionTimePassed = 0;
      currentSession = Math.min(SESSIONS_COUNT, currentSession + 1);
    } else if (
      sessionTimePassedSeconds < SESSION.workDurationSeconds &&
      actualSessionTimePassed >= SESSION.workDurationSeconds
    ) {
      playTimestamp = null;
      sessionTimePassedSeconds = SESSION.workDurationSeconds;
      actualSessionTimePassed = SESSION.workDurationSeconds;
    }
  }
  const secondsToEndLeft = Math.max(
    0,
    (SESSIONS_COUNT - currentSession + 1) * SESSION.durationSeconds - actualSessionTimePassed
  );

  return {
    tickTimestamp: nowTimestamp,
    endTimestamp: nowTimestamp + secondsToEndLeft * 1000,
    sessionTimePassedSeconds,
    playTimestamp,
    session: SESSION,
    currentSession,
    sessionsCount: SESSIONS_COUNT,
    isManualRewind: false,
  };
};

export const calculateActualSessionTimePassedSeconds = ({
  playTimestamp,
  tickTimestamp,
  sessionTimePassedSeconds,
}: WorkSessionsState) => {
  if (playTimestamp === null) {
    return sessionTimePassedSeconds;
  }
  const diffSeconds = (tickTimestamp - playTimestamp) / 1000;

  return sessionTimePassedSeconds + diffSeconds;
};
